import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {AttributeColumn} from '../dynamic-form-builder/dynamic-form-builder.component';
import {ConfService} from '../../conf.service';
import {SettingsComponent} from '../settings.component';
import {AppComponent} from '../../app.component';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {JsonEditorComponent} from 'ang-jsoneditor';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent, MatDialog, MatTabGroup} from '@angular/material';
import {Config, Menu} from '../environment-settings/environment-settings.component';
import {EmailtemplateListenerService} from '../../emailtemplate-listener.service';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {AccountInfoService} from '../../user/account-info.service';

@Component({
  selector: 'app-developer-experience-settings',
  templateUrl: './developer-experience-settings.component.html',
  styleUrls: ['./developer-experience-settings.component.scss']
})

export class DeveloperExperienceSettingsComponent implements OnInit, OnChanges {

  options: Config = {multi: false};
  devexMenu: Menu[] = [
    {
      name: 'Consumers',
      iconClass: 'fa fa-user-circle-o',
      active: false,
      toolTip: 'Consumers',
      submenu: [
        // {name: 'Manage Consumers', key: 'Manage Consumers', icon: 'fa fa-address-card', toolTip: 'Manage Consumers'},
        {name: 'Pending Approval', key: 'Pending Approval', icon: 'fa fa-user-times', toolTip: 'Pending Approval'}
      ]
    },
    {
      name: 'Self-service Forms',
      iconClass: 'fa fa-file-text-o',
      active: false,
      toolTip: 'Forms',
      submenu: [
        {name: 'Sign Up Form', key: 'Sign up form', icon: 'fa fa-user-plus', toolTip: 'Sign up form'},
        {name: 'Login Form', key: 'Sign in form', icon: 'fa fa-sign-in', toolTip: 'Sign in form'},
        {name: 'Change Password Form', key: 'Change Password', icon: 'fa fa-key', toolTip: 'Change Password'}
      ]
    },
    {
      name: 'Email Preferences',
      iconClass: 'fa fa-envelope-o',
      active: false,
      toolTip: 'Email Preferences',
      submenu: [
        {name: 'Approvers', key: 'Approvers', icon: 'fa fa-id-badge', toolTip: 'Approvers'},
        // {name: 'Templates', key: 'Templates', icon: 'fa fa-columns', toolTip: 'Templates'},
        // {name: 'Email Templates', key: 'emailTemplateBuilder', icon: 'fa fa-envelope', toolTip: 'Email Templates'}
      ]
    },
    {
      name: 'General',
      iconClass: 'fa fa-cog',
      active: false,
      toolTip: 'General',
      submenu: [
        {name: 'Configuration', key: 'Configuration', icon: 'fa fa-cogs', toolTip: 'Configuration'},
        {name: 'Redirect', key: 'redirectLinks', icon: 'fa fa-external-link', toolTip: 'Redirect Routes'},
      ]
    }
  ];
  selectedMenu = 'PendingApproval';

  myInputMsg = {
    templateName: 'DevexUser',
    version: 'v1',
    category: 'DevexManagement',
    description: 'Template for user registration'
  };
  body: any;
  @Input() isEditTemplate: boolean;
  @Input() removeMatCardPadding: boolean;
  loading = false;
  ignorePermissions = false;

  redirectSelectedOption = 'credentials';
  redirectOptions = [{'displayName': 'Redirect to Credentials Page', 'value': 'credentials'},
    {'displayName': 'Redirect to route', 'value': 'route'},
    {'displayName': 'Custom Page', 'value': 'custom'}];
  routeOptions = ['devex'];
  customRoute = '';
  selectRoute = '';
  redirectForm: any;
  cssProperties: any;

  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');

  adminEmails = [];

  separatorKeysCodes = [ENTER, COMMA];
  selectable = true;
  removable = true;
  addOnBlur = true;

  tableDefinition: AttributeColumn[] = [
    {
      name: 'displayName',
      headerDisplayName: 'Display Name',
      type: 'input',
      placeholder: 'Display Name',
      description: 'Display Name',
      disabled: false
    },
    {
      name: 'attributeName',
      headerDisplayName: 'Name',
      type: 'input',
      placeholder: 'Attribute Name',
      selectableOptions: [],
      description: 'Name of the Attribute',
      disabled: false
    },
    {
      name: 'type',
      headerDisplayName: 'Data Type',
      type: 'selector',
      selectableOptions: ['Integer', 'String'],
      disabled: false,
      disabledPlaceholder: 'Please select a Database'
    },
    {
      name: 'fieldType',
      headerDisplayName: 'Form Field Type',
      type: 'selector',
      selectableOptions: ['text_field'],
      optionsDisplayNames: ['Text Input'],
      disabled: false
    },
    {
      name: 'size',
      headerDisplayName: 'Size',
      type: 'input',
      placeholder: 'Size',
      disabled: false
    },
    {
      name: 'precision',
      headerDisplayName: 'Precision',
      type: 'input',
      placeholder: 'Precision',
      disabled: false
    },
    {
      name: 'attributeType',
      headerDisplayName: 'Key',
      type: 'selector',
      selectableOptions: ['None', 'Primary', 'Unique'],
      disabled: false
    },
    {
      name: 'required',
      headerDisplayName: 'Required',
      type: 'checkbox',
      description: 'Required',
      disabled: false
    },
    {
      name: 'autoIncrement',
      headerDisplayName: 'Auto-Increment',
      type: 'checkbox',
      description: 'Auto-Increment',
      disabled: false
    },
    {
      name: '',
      headerDisplayName: '',
      type: 'more',
      disabled: false,
      dataTypeFilter: []
    }
  ];
  newAttribute = {
    fieldType: 'text_field',
    attributeType: 'None',
    customType: false,
    apiAccessPolicy: 'None',
    attributeName: null,
    type: null,
    array: false,
    size: null,
    precision: null,
    autoIncrement: false,
    defaultValue: null,
    dataStoragePolicy: 'None',
    description: null,
    displayName: '',
    displayPolicy: null,
    required: false,
    subType: [],
    formAttribute: true
  };
  formAttributes: any[] =[];

  changePasswordFormAttributes: any;

  loginFormAttributes: any[] = [];
  loginFormTableDefinition: AttributeColumn[] = [
    {
      name: 'displayName',
      headerDisplayName: 'Display Name',
      type: 'input',
      placeholder: 'Display Name',
      description: 'Display Name',
      disabled: false
    },
    {
      name: 'attributeName',
      headerDisplayName: 'Name',
      type: 'input',
      placeholder: 'Attribute Name',
      selectableOptions: [],
      description: 'Name of the Attribute',
      disabled: false
    },
    {
      name: 'fieldType',
      headerDisplayName: 'Form Field Type',
      type: 'selector',
      selectableOptions: ['text_field'],
      optionsDisplayNames: ['Text Input'],
      disabled: false
    },
    {
      name: 'required',
      headerDisplayName: 'Required',
      type: 'checkbox',
      description: 'Required',
      disabled: false
    },
    {
      name: '',
      headerDisplayName: '',
      type: 'more',
      disabled: false,
      dataTypeFilter: []
    }
  ];

  loginFormNewAttribute = {
    fieldType: 'text_field',
    displayName: '',
    attributeName: '',
    required: false,
  };
  selectDatabase: string;
  databaseAvailable = false;
  databases: any;
  datatypes: any;
  dataTypeFilter = [];
  selectedDatatypeFilter: string;
  entityAndVersion: any;
  isSelectedDatabaseNatureNoSQL = false;

  brandingType: any ='powered by apiplatform.io';
  brandingTypes = [
    {
      value: 'powered by apiplatform.io'
    },
    {
      value: 'partnered with apiplatform.io'
    }
  ];
  brandingLocation = 'belowlogoinheader';
  brandingLocations = [
    {
      value: 'Left',
      loc: 'belowlogoinheader'
    },
    {
      value: 'Right',
      loc: 'rightinheader'
    }
  ]

  partnerKey: string;
  partnerSettingsData: any;

  componentLoading = true;
  updatingFormSchema = false;

  adminEmailsForm: any;

  origAdminEmailsForm: any;
  origRegistrationForm: any;
  origLoginForm: any;
  origChangePasswordForm: any;
  origRedirectForm: any;
  origCssProperties: any;


  ///
  showPathParameters: boolean;
  devExURL = '';
  parameterData = [];
  pathParameter = [];
  isCountOfResAtt: boolean;
  pathParameterSegregator: any;
  find: any;
  pathParameterStopper: any;
  pathParameterValue: any;
  headers = [];
  queryParams = [];
  prerequisites: any;
  showAPIBrowser = true;
  signUpformExecutorModel: any;
  signUpformHttpOperation = '';
  httpOperations = [
    {'name': 'GET'},
    {'name': 'POST'},
    {'name': 'PUT'},
    {'name': 'PATCH'},
    {'name': 'DELETE'}
  ];

  selectedEnvironment: any;
  data: any;
  totalServices: any;

  signUpformRawRequestBody: any;
  signUpformRequestBodySelected: any;
  signUpformData: any;

  signUpRequestBody: any;
  signUpRequestBodySelected = 'none';
  signUpRawRequestBody: any;
  signUpFormURLEncodedTrue = true;
  signUpFormDataTrue = true;
  signUpFormData = [];
  signUpHeadersData = [];

  signUpExecutor: any;
  @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
  @ViewChild(MatTabGroup) tabref: MatTabGroup;
  ///
  createTemplatePayload = {
    partner: '',
    account: '',
    name: '',
    version: '',
    category: '',
    description: '',
    subject: '',
    body: '',
    inputType: ''
  };

  // labels = {'a': 'devex=>signup'};
   Object = Object;
  labels = [{'tab_name': 'User Signup', 'template_name' : 'devex=>signupinitial', 'version' : 'v1', 'data' : {}, 'isDataFound' : false, 'isDataLoading': true},
    {'tab_name': 'Admin Signup', 'template_name' : 'devex=>admin_signup', 'version' : 'v1', 'data' : {}, 'isDataFound' : false, 'isDataLoading': true},
    {'tab_name': 'User Approval', 'template_name' : 'devex=>user_approval', 'version' : 'v1', 'data' : {}, 'isDataFound' : false, 'isDataLoading': true},
    {'tab_name': 'User Reject', 'template_name' : 'devex=>user_reject', 'version' : 'v1', 'data' : {}, 'isDataFound' : false, 'isDataLoading': true},
    {'tab_name': 'Password Change', 'template_name' : 'devex=>password_change', 'version' : 'v1', 'data' : {}, 'isDataFound' : false, 'isDataLoading': true}
  ];

  // tslint:disable-next-line:max-line-length
  constructor(private confPost: ConfService,
              private _service: ConnecttocrudService,
              public accountInfoService: AccountInfoService,
              public platform: LeftpanelComponent,
              public emailTemplatesListenerInstance: EmailtemplateListenerService,
              public dialog: MatDialog) { }

  async ngOnInit() {
    await this.confPost.getPartnerKey(this.partner).toPromise().then( response => {
      this.partnerKey =  response['pkey'];
    });
    if (this.platform.datatypes !== null && this.platform.datatypes !== undefined) {
      this.datatypes = this.platform.datatypes;
    } else {
      await this.confPost.getDataTypes().toPromise().then(data => {
            this.datatypes = data;
            this.platform.datatypes = data;
          },
          error => {
            this.platform.handleErrorGracefully(error, 'Error while getting list of data types. Please try again after sometime.');
          });
    }

    this.retrievePartnerSettings();

    this.retriveTemplateData();
  }

  retrievePartnerSettings() {
    this.componentLoading = true;
    Promise.resolve(this.getSettingsData()).then(async resp => {

      const temp = this.partnerSettingsData['environments'].filter((obj) => obj['name'] === this.partner);
      if (temp && temp.length > 0) {
        this.selectedEnvironment = temp[0];
        this.totalServices = this.selectedEnvironment['services'];
        const temp1  = this.totalServices.filter((obj) => obj['name'] === 'Developer Experience');
        if (temp1 && temp1.length > 0) {
          this.data = temp1[0];
        }
      }

      this.getDatabases();
      this.setDevexConfigs();
      this.setTableData();
      this.componentLoading = false;
    }, error => {


    });
  }

  ngOnChanges(changes: SimpleChanges) {
    let executeRetrieve = false;

    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        if (propName === 'partner' || propName === 'account') {
          executeRetrieve = true;
        }
      }
    }

    if (executeRetrieve) {
      this.retrievePartnerSettings();
    }
  }

  retriveTemplateData() {
    // @ts-ignore
    for (const list of this.labels) {
        if (!list.isDataFound && list.isDataLoading) {
          // tslint:disable-next-line:max-line-length
          this.confPost.getData('campaign', 'campaign', 'v1', 'emailTemplate', 'partner=' + this.partner + '&account=' + this.account + '&name=' + list.template_name + '&version=' + list.version).subscribe(response => {
            let resp: any;
            resp = response;
            if (resp.length > 0) {
              list.data = resp[0];
              list.isDataFound = true;
            }
            setTimeout(() => {
              list.isDataLoading = false;
            }, 100);

            if (this.createTemplatePayload.inputType === 'simpleText' || this.createTemplatePayload.inputType === 'freeText') {
              this.tabref.selectedIndex = 0;
            } else if (this.createTemplatePayload.inputType === 'htmlContent') {
              this.tabref.selectedIndex = 1;
            } else if (this.createTemplatePayload.inputType === 'emailDesigner' || this.createTemplatePayload.inputType === 'advancedBuilderText') {
              this.tabref.selectedIndex = 2;
            }
          });
        }
    }
  }

  setUpTemplateData(list_name) {
      this._service.addEmailTemplate({
        partner: this.partner,
        account: this.account,
        name: list_name.template_name,
        version: list_name.version,
        category: 'Devex Management',
        description: '',
        inputType: 'simpleText'
      }, 'v1', 'campaign', 'campaign', 'emailTemplate').subscribe(data => {

        list_name.isDataFound = false;
        list_name.isDataLoading = true;
        this.retriveTemplateData();
      }, error => {

      });
  }

  setDevexConfigs() {
    for (const env1 of this.partnerSettingsData['environments']) {
      if (env1['name'] === this.partner) {
        const devex = env1['services'].filter(element => element.name === 'Developer Experience');
        for (const config of devex[0]['configurations']) {
          if (config && config !== null && config !== undefined) {
            if (config['name'] === 'Developer Experience') {
              this.formAttributes = config['devex_configurations'] ? config['devex_configurations']['devex_signup'] ? config['devex_configurations']['devex_signup']['form_attributes'] ? config['devex_configurations']['devex_signup']['form_attributes'] : [] : [] : [];
              this.loginFormAttributes = config['devex_configurations'] ? config['devex_configurations']['devex_login'] ? config['devex_configurations']['devex_login']['form_attributes'] ? config['devex_configurations']['devex_login']['form_attributes'] : [] : [] : [];
              this.adminEmailsForm = config['devex_configurations'] ? config['devex_configurations']['devex_login'] ? config['devex_configurations']['admin_emails'] ? config['devex_configurations']['admin_emails'] : [] : [] : [];
              this.changePasswordFormAttributes = config['devex_configurations'] ? config['devex_configurations']['devex_change_password'] ? config['devex_configurations']['devex_change_password']['form_attributes'] ? config['devex_configurations']['devex_change_password']['form_attributes'] : [] : [] : [];
              this.selectDatabase = config['devex_configurations'] ? config['devex_configurations']['devex_signup'] ? config['devex_configurations']['devex_signup']['database'] ? config['devex_configurations']['devex_signup']['database'] : '' : '' : '';
              this.redirectForm = config['devex_configurations'] ? config['devex_configurations']['devex_login'] ? config['devex_configurations']['devex_login']['redirect_routes'] ? config['devex_configurations']['devex_login']['redirect_routes'] : {type: '', value: ''} : {type: '', value: ''} : {type: '', value: ''};

              this.cssProperties = config['devex_configurations'] ? config['devex_configurations']['css_properties'] ? config['devex_configurations']['css_properties'] : {} : {};

              this.origRegistrationForm = JSON.parse(JSON.stringify(this.formAttributes));
              this.origLoginForm = JSON.parse(JSON.stringify(this.loginFormAttributes));
              this.origAdminEmailsForm = JSON.parse(JSON.stringify(this.adminEmailsForm));
              this.origChangePasswordForm = JSON.parse(JSON.stringify(this.changePasswordFormAttributes));
              this.origRedirectForm = JSON.parse(JSON.stringify(this.redirectForm));
              this.origCssProperties = JSON.parse(JSON.stringify(this.redirectForm));

              if (this.selectDatabase !== '') {
                this.databaseAvailable = true;
                this.filterDataTypes(this.selectDatabase);
              }

              if (this.adminEmailsForm.length > 0) {
                this.adminEmails = [];
                for (const item of this.adminEmailsForm) {
                  this.adminEmails.push(item.email);
                }
              }

              if (this.redirectForm.type && this.redirectForm.type !== '') {
                this.redirectSelectedOption = this.redirectForm.type;
                if (this.redirectForm.value && this.redirectForm.value !== '') {
                  if (this.redirectSelectedOption === 'route') {
                    this.selectRoute = this.redirectForm.value;
                  } else if (this.redirectSelectedOption === 'custom') {
                    this.customRoute = this.redirectForm.value;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  setTableData() {
    const values = [];
    for (const dataType of this.dataTypeFilter) {
      if (dataType.data_types[0].type !== 'Object') {
        values.push(dataType.data_types[0].type);
      }
    }
    this.tableDefinition[this.tableDefinition.length - 1].dataTypeFilter = this.dataTypeFilter;
    this.tableDefinition[2].selectableOptions = values;
    if (values.length === 0) {
      this.tableDefinition[2].disabled = true;
    } else {
      this.tableDefinition[2].disabled = false;
    }
  }

  saveDescription(value) {
    this.body = value;
  }

  refreshSubjectAndBody(selectedIndex) {
    if (selectedIndex === 0) {
      this.createTemplatePayload.inputType = 'simpleText';
    } else if (selectedIndex === 1) {
      this.createTemplatePayload.inputType = 'htmlContent';
    } else if (selectedIndex === 2) {
      this.createTemplatePayload.inputType = 'emailDesigner';
    }
    // this.subject = '';
    // this.body = '';
  }

  getSettingsData() {
    return new Promise((resolve, reject) => {
      if (this.partner === localStorage.getItem('partner')) {
        if (this.platform.settingsData !== null && this.platform.settingsData !== undefined) {
          this.partnerSettingsData = this.platform.settingsData['body'][0];
          resolve('success');
        } else {
          this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(response => {
            if (response['body'] && response['body'][0]) {
              this.platform.settingsData = response;
              this.partnerSettingsData = response['body'][0];
              resolve('success');
            } else {
              reject('failed');
            }
          }, error => {
            reject(error);
          });
        }
      } else {
        this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(response => {
          if (response['body'] && response['body'][0]) {
            this.partnerSettingsData = response['body'][0];
            resolve('success');
          } else {
            reject('failed');
          }
        }, error => {
          reject(error);
        });
      }
    });
  }

  getDatabases() {
    for (const env1 of this.partnerSettingsData['environments']) {
      if (env1['name'] === this.partner) {
        const databaseObject = env1['services'].filter(element => element.type === 'databases');
        this.databases = databaseObject[0]['configurations'];
      }
    }
  }

  async filterDataTypes(val) {
    this.getDatabaseTypeForDatabaseName(val);
    this.dataTypeFilter = [];
    this.datatypes.filter(items => {
      if (items.database_type === this.selectedDatatypeFilter) {
        this.dataTypeFilter.push(items);
      }
    });
    if (this.selectedDatatypeFilter && this.selectedDatatypeFilter === 'mongodb') {
      await this.platform.getCustomTypes(val);
      this.entityAndVersion = this.platform.entityAndVersion;
    } else {
      this.entityAndVersion = [];
    }
    if (this.entityAndVersion) {
      for (let i = 0; i < this.entityAndVersion.length; i++) {
        const newType = {
          'database_type': 'mongodb',
          'data_types': [
            {
              'type': this.entityAndVersion[i],
              'default_length': '',
              'min_length': '',
              'max_length': ''
            }]
        };
        this.dataTypeFilter.push(newType);
      }
    }
    this.setTableData();
  }

  getDatabaseTypeForDatabaseName(val) {
    this.databases.filter(items => {
      if (items.database_name === val) {
        this.selectedDatatypeFilter = items.database_type;
        if (items.hasOwnProperty('is_nosql')) {
          this.isSelectedDatabaseNatureNoSQL = items.is_nosql;
        }
      }
    });
  }

  updateConfigurationCssProperties() {
    Promise.resolve(this.updatePartnerDevex('css_attributes')).then(async resp => {
      this.updatingFormSchema = true;
      this.platform.openSnackBar('Configuration Updated Successfully.', 'Success', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }, error => {
      this.platform.openSnackBar(error, 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }
  updateFormAttributes() {

    const formData = JSON.parse(JSON.stringify(this.formAttributes));
    let errorFound = false;

    if (this.selectDatabase && this.selectDatabase !== '') {
      if (formData.filter(e => e.attributeName === 'email').length > 0) {
        if (formData.filter(e => e.attributeName === 'password').length > 0 || formData.filter(e => e.attributeName === 'passwordChanged').length > 0) {
          this.platform.openSnackBar('\'password\' field will be automatically added to the entity. Please remove the field in form attributes. ', 'Error', {
            duration: 8000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          errorFound = true;
        }
      } else {
        this.platform.openSnackBar('Please add a field for Email as : \'email\'.', 'Error', {
          duration: 4000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        errorFound = true;
      }
    } else {
      errorFound = true;
      this.platform.openSnackBar('Please select a valid database.', 'Error', {
        duration: 4000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }

    if (!errorFound) {
      Promise.resolve(this.updatePartnerDevex('registration_form', false)).then(async resp => {
        this.updatingFormSchema = true;
        formData.push({
          'fieldType': 'text_field',
          'attributeType': 'None',
          'customType': false,
          'apiAccessPolicy': 'None',
          'attributeName': 'password',
          'type': 'String',
          'array': false,
          'size': null,
          'precision': null,
          'autoIncrement': false,
          'defaultValue': null,
          'dataStoragePolicy': 'None',
          'description': null,
          'displayName': 'Password',
          'displayPolicy': null,
          'required': false,
          'subType': [],
          'formAttribute': false
        });

        formData.push({
          'fieldType': 'text_field',
          'attributeType': 'None',
          'customType': false,
          'apiAccessPolicy': 'None',
          'attributeName': 'status',
          'type': 'String',
          'array': false,
          'size': null,
          'precision': null,
          'autoIncrement': false,
          'defaultValue': null,
          'dataStoragePolicy': 'None',
          'description': null,
          'displayName': 'Status',
          'displayPolicy': null,
          'required': false,
          'subType': [],
          'formAttribute': false
        });

        formData.push({
          'fieldType': 'text_field',
          'attributeType': 'None',
          'customType': false,
          'apiAccessPolicy': 'None',
          'attributeName': 'passwordChanged',
          'type': 'Boolean',
          'array': false,
          'size': null,
          'precision': null,
          'autoIncrement': false,
          'defaultValue': null,
          'dataStoragePolicy': 'None',
          'description': null,
          'displayName': 'Change Password',
          'displayPolicy': null,
          'required': false,
          'subType': [],
          'formAttribute': false
        });

        // const payload = {
        //   'partner': this.partner,
        //   'account': this.account,
        //   'pkey': this.partnerKey,
        //   'apikey': localStorage.getItem('apikey'),
        //   'database': this.selectDatabase,
        //   'form_attributes': formData,
        //   'email': localStorage.getItem('signInEmail'),
        //   'session': localStorage.getItem('sessionID'),
        //   'logsEntityPayload': [{'attributeType': 'None', 'customType': false, 'apiAccessPolicy': 'None', 'attributeName': 'firstName', 'type': 'String', 'array': false, 'size': null, 'precision': null, 'autoIncrement': false, 'defaultValue': null, 'dataStoragePolicy': 'None', 'description': null, 'displayName': '', 'displayPolicy': null, 'required': false, 'subType': []}, {'attributeType': 'None', 'customType': false, 'apiAccessPolicy': 'None', 'attributeName': 'lastName', 'type': 'String', 'array': false, 'size': null, 'precision': null, 'autoIncrement': false, 'defaultValue': null, 'dataStoragePolicy': 'None', 'description': null, 'displayName': '', 'displayPolicy': null, 'required': false, 'subType': []}, {'attributeType': 'None', 'customType': false, 'apiAccessPolicy': 'None', 'attributeName': 'status', 'type': 'String', 'array': false, 'size': null, 'precision': null, 'autoIncrement': false, 'defaultValue': null, 'dataStoragePolicy': 'None', 'description': null, 'displayName': '', 'displayPolicy': null, 'required': false, 'subType': []}, {'attributeType': 'None', 'customType': false, 'apiAccessPolicy': 'None', 'attributeName': 'email', 'type': 'String', 'array': false, 'size': null, 'precision': null, 'autoIncrement': false, 'defaultValue': null, 'dataStoragePolicy': 'None', 'description': null, 'displayName': '', 'displayPolicy': null, 'required': false, 'subType': []}]
        // };

        const payload = {
          'database': this.selectDatabase,
          'form_attributes': formData
        };

        if (!errorFound) {
          const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
            data: {
              message: 'Form updation under progress. Please don\'t close the window'
            }
          });
          this.confPost.postDevexConsumerEntitiesWithFormAttributes(this.partner, this.account, this.partnerKey, payload).subscribe(async response1 => {
            this.updatingFormSchema = false;
            this.platform.openSnackBar('Configuration Updated Successfully.', 'Success', {
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            loaderDialog.close();
          }, error => {
            loaderDialog.close();
            this.platform.openSnackBar('Unable to update configurations. Please try again later.', 'Error', {
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          });
        } else {
        }
      }, error => {

        this.platform.openSnackBar(error, 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
    }
  }


  updateLoginFormAttributes() {
    Promise.resolve(this.updatePartnerDevex('login_form')).then(async resp => {
      this.updatingFormSchema = true;
        this.platform.openSnackBar('Configuration Updated Successfully.', 'Success', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }, error => {
        this.platform.openSnackBar(error, 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
  }

  updateChangePasswordFormAttributes() {
    Promise.resolve(this.updatePartnerDevex('change_password_form')).then(async resp => {
      this.updatingFormSchema = true;
      this.platform.openSnackBar('Configuration Updated Successfully.', 'Success', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }, error => {
      this.platform.openSnackBar(error, 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  patchConfiguration(partner, account, version, entity, id, payload) {
    return new Promise((resolve, reject) => {
      this.platform.patchEntityData(partner, account, version, entity, id, payload).then(resp => {
        resolve('success');
      }, error => {
        reject(error);
      });
    });
  }

  updatePartnerDevex(type, showSuccessMessage = true) {
    return new Promise((resolve, reject) => {
      let noChanges = true;
      if (type === 'registration_form') {
        noChanges = JSON.stringify(this.formAttributes) === JSON.stringify(this.origRegistrationForm);
      } else if (type === 'login_form') {
        noChanges = JSON.stringify(this.loginFormAttributes) === JSON.stringify(this.origLoginForm);
      } else if (type === 'admin_emails') {
        noChanges = JSON.stringify(this.adminEmailsForm) === JSON.stringify(this.origAdminEmailsForm);
      } else if (type === 'change_password_form') {
        noChanges = JSON.stringify(this.changePasswordFormAttributes) === JSON.stringify(this.origChangePasswordForm);
      } else if (type === 'redirect_routes') {
        noChanges = JSON.stringify(this.redirectForm) === JSON.stringify(this.origRedirectForm);
      } else if (type === 'css_attributes') {
        noChanges = JSON.stringify(this.cssProperties) === JSON.stringify(this.origCssProperties);
      }
      if (noChanges) {
        reject('There is no new information to update.');
        this.platform.openSnackBar('There is no new information to update.', 'Error', {
          duration: 4000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      } else {
        this.updatingFormSchema = true;
        let index = 0;
        for (const env1 of this.partnerSettingsData['environments']) {
          if (env1 && env1 !== null && env1 !== undefined) {
            this.confPost.getSettingsV2CRUD(env1['name'], env1['name'], false).subscribe(async response1 => {
              let updateFlag = false;
              if (response1 && response1['body'] && response1.status === 200) {
                for (const env2 of response1['body'][0]['environments']) {
                  if (env2 && env2 !== null && env2 !== undefined) {
                    const timeService = env2['services'].filter(element => element.name === 'Developer Experience');
                    if (timeService.length > 0) {
                      for (let i = 0; i < timeService[0]['configurations'].length; i++) {
                        const config = timeService[0]['configurations'][i];
                        if (config && config !== null && config !== undefined) {
                          if (config['name'] === 'default') {
                            if (!timeService[0]['configurations'][i]['devex_configurations']) {
                              timeService[0]['configurations'][i]['devex_configurations'] = {};
                            }
                            if (type === 'registration_form') {
                              if (!timeService[0]['configurations'][i]['devex_configurations']['devex_signup']) {
                                timeService[0]['configurations'][i]['devex_configurations']['devex_signup'] = {};
                              }
                              timeService[0]['configurations'][i]['devex_configurations']['devex_signup']['database'] = this.selectDatabase;
                              timeService[0]['configurations'][i]['devex_configurations']['devex_signup']['form_attributes'] = this.formAttributes;
                              updateFlag = true;
                            }
                            if (type === 'login_form') {
                              if (!timeService[0]['configurations'][i]['devex_configurations']['devex_login']) {
                                timeService[0]['configurations'][i]['devex_configurations']['devex_login'] = {};
                              }
                              timeService[0]['configurations'][i]['devex_configurations']['devex_login']['form_attributes'] = this.loginFormAttributes;
                              updateFlag = true;
                            }
                            if (type === 'change_password_form') {
                              if (!timeService[0]['configurations'][i]['devex_configurations']['devex_change_password']) {
                                timeService[0]['configurations'][i]['devex_configurations']['devex_change_password'] = {};
                              }
                              timeService[0]['configurations'][i]['devex_configurations']['devex_change_password']['form_attributes'] = this.changePasswordFormAttributes;
                              updateFlag = true;
                            }

                            if (type === 'admin_emails') {
                              if (!timeService[0]['configurations'][i]['devex_configurations']['admin_emails']) {
                                timeService[0]['configurations'][i]['devex_configurations']['admin_emails'] = {};
                              }
                              timeService[0]['configurations'][i]['devex_configurations']['admin_emails'] = this.adminEmailsForm;
                              updateFlag = true;
                            }

                            if (type === 'redirect_routes') {
                              if (!timeService[0]['configurations'][i]['devex_configurations']['devex_login']) {
                                timeService[0]['configurations'][i]['devex_configurations']['devex_login'] = {};
                              }
                              timeService[0]['configurations'][i]['devex_configurations']['devex_login']['redirect_routes'] = this.redirectForm;
                              updateFlag = true;
                            }

                            if (type === 'css_attributes') {
                              if (!timeService[0]['configurations'][i]['devex_configurations']['css_properties']) {
                                timeService[0]['configurations'][i]['devex_configurations']['css_properties'] = {};
                              }
                              timeService[0]['configurations'][i]['devex_configurations']['css_properties'] = this.cssProperties;
                              updateFlag = true;
                            }
                          }
                        }
                      }
                    }
                  }
                }
                if (updateFlag) {
                  this.updatingFormSchema = false;
                  // console.log(response1['body'][0]);
                  await this.patchConfiguration('services', 'services', 'v2', 'settings', response1['body'][0]['id'], response1['body'][0]).then(resp => {
                    index += 1;
                    if (index === this.partnerSettingsData['environments'].length) {
                      this.updatingFormSchema = false;
                      if (type === 'registration_form') {
                        this.origRegistrationForm = JSON.parse(JSON.stringify(this.formAttributes));
                      } else if (type === 'login_form') {
                        this.origLoginForm = JSON.parse(JSON.stringify(this.loginFormAttributes));
                      } else if (type === 'admin_emails') {
                        this.origAdminEmailsForm = JSON.parse(JSON.stringify(this.adminEmailsForm));
                      } else if (type === 'change_password_form') {
                        this.origChangePasswordForm = JSON.parse(JSON.stringify(this.changePasswordFormAttributes));
                      } else if (type === 'redirect_routes') {
                        this.origRedirectForm = JSON.parse(JSON.stringify(this.redirectForm));
                      }
                      if (showSuccessMessage) {
                        this.platform.openSnackBar('Configuration saved successfully.', 'Success', {
                          duration: 4000,
                          verticalPosition: 'top',
                          horizontalPosition: 'center'
                        });
                      }
                      resolve('success');
                    }
                  }, error => {
                    index += 1;
                    this.updatingFormSchema = false;
                    resolve('success');
                    this.platform.openSnackBar('Error while updating configurations for ' + response1['body'][0]['partner'] + '. Please contact administrator.', 'Error', {
                      duration: 4000,
                      verticalPosition: 'top',
                      horizontalPosition: 'center'
                    });
                  });
                } else {
                  resolve('success');
                  this.updatingFormSchema = false;
                  index += 1;
                }
              }
            }, error => {
              this.updatingFormSchema = false;
              this.platform.openSnackBar('Unable to update configurations. Please try again later.', 'Error', {
                duration: 4000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
              reject('Unable to update configurations. Please try again later.');
            });
          } else {
            this.updatingFormSchema = false;
            this.platform.openSnackBar('Unable to update configurations. Please try again later.', 'Error', {
              duration: 4000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            reject('Unable to update configurations. Please try again later.');
          }
        }
      }
    });
  }

  updateRedirectsRoutes() {

    if (this.redirectSelectedOption && this.redirectSelectedOption !== '') {
      let error1 = false;
      if (this.redirectSelectedOption === 'route' && (!this.selectRoute || this.selectRoute === '')) {
        error1 = true;
        this.platform.openSnackBar('Please select a valid route.', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
      if (!error1) {
        if (this.redirectSelectedOption === 'credentials') {
          this.redirectForm.type = 'credentials';
        } else if (this.redirectSelectedOption === 'route') {
          this.redirectForm.type = 'route';
          this.redirectForm.value = this.selectRoute;
        } else if (this.redirectSelectedOption === 'custom') {
          this.redirectForm.type = 'custom';
          this.redirectForm.value = this.customRoute;
        }
        Promise.resolve(this.updatePartnerDevex('redirect_routes')).then(async resp => {
          this.updatingFormSchema = true;
          this.platform.openSnackBar('Configuration Updated Successfully.', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }, error => {
          this.platform.openSnackBar(error, 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        });
      }
    } else {
      this.platform.openSnackBar('Please select a valid option.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  updateAdminEmails() {
    if (!(this.adminEmails.length > 0)) {
      this.platform.openSnackBar('Please enter atleast one email.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    } else {
      this.adminEmailsForm = [];
      for (const email of this.adminEmails) {
        this.adminEmailsForm.push({email: email});
      }
      Promise.resolve(this.updatePartnerDevex('admin_emails')).then(async resp => {
        this.updatingFormSchema = true;
        this.platform.openSnackBar('Configuration Updated Successfully.', 'Success', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }, error => {
        this.platform.openSnackBar('Unable to update configurations. Please try again later.', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
    }
  }

  addAdminEmail(event: MatChipInputEvent): void {
    if (event.value) {
      if (this.validateEmail(event.value)) {
        this.adminEmails.push(event.value);
      }
      // else {
      //   this.adminEmails.push({value: event.value, invalid: true});
      // }
    }
    if (event.input) {
      event.input.value = '';
    }
  }

  private validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  removeAdminEmail(data: any): void {
    const index = this.adminEmails.indexOf(data);

    if (index >= 0) {
      this.adminEmails.splice(index, 1);
    }
    // if (this.adminEmails.indexOf(data) >= 0) {
    //   this.adminEmails.splice(this.adminEmails.indexOf(data), 1);
    // }
  }

  setActiveMenu(event) {
    if (event.key !== '') {
      this.selectedMenu = event.key;
    }
  }
  hello() {
  }
}
